<template>
  <div :class="{content: true,empty: list.length === 0}">
    <div class="wrapper">
      <div class="filters">
        <evaluationFilter ref="evaluationFilter" :filters="filters" :type="'unique'" :date="dateConfig" @getFilters="getFilters" />
      </div>
      <div class="list">
        <div class="handles">
          <div class="btn" @click="getList">
            <img src="@assets/img/resources/fresh.svg" alt="fresh">
            刷新
          </div>
          <div class="btn greenBtn ml10 outRank-container" @mouseover.stop="isShow=true" @mouseout.stop="isShow=false">
            <img src="@assets/img/resources/export.svg" alt="export">
            导出打分
            <div class="outRankContainer">
              <p></p>
              <ul v-show="isShow" class="outRank">
                <li @click="download_type=0;exportRes()">所选栏目</li>
                <li @click="download_type=1;exportRes()">全部栏目</li>
              </ul>
            </div>
          </div>
          <div class="btn greenBtn ml10" @click="goPrint">
            <img src="@assets/img/common/printing.svg" alt="print">
            打印打分
          </div>
        </div>
        <div class="titleLine">
          <span class="title">播出标题</span>
          <span class="score w110">播出日期</span>
          <span class="name">播出时长</span>
          <span class="name">供片</span>
          <span class="name">记者</span>
          <span class="score">考评</span>
          <span class="name">摄像</span>
          <span class="score">考评</span>
        </div>
        <empty :mTop="30" v-if="list.length === 0" :msg="'暂无考评数据'" />
        <div v-for="(l, i) in list" :key="i">
          <div class="item">
            <span class="grayBg"></span>
            <div class="inner">
              <div :class="{title: true, ft16: true, sec: true, disabled: !l.is_available}">
                <span @click="goTandem(l)">{{l.title}}</span>
                <img class="toggler" v-if="l.list.length > 0" :src="l.showRelated?icons.up:icons.down" alt="icon" @click="toggleRelated(l)">
              </div>
              <div class="score sec w110">{{l.release_time}}</div>
              <div class="name sec">{{l.durantion}}</div>
              <div class="name sec">{{l.depart_title}}</div>
              <div class="name sec">{{l.reporters}}</div>
              <div class="score sec">
                <div v-if="l.is_available && l.reporter_res.score_type == 1 && l.reporter_res.rate.filter(g => g.selected).length === 0" class="grade none" @click="showGrades(l, 'reporter_res')">
                  <img src="@assets/img/common/grade.svg" alt="grade">
                  打分
                </div>
                <div class="grade" v-if="l.reporter_res.score_type == 1 && l.reporter_res.rate.filter(g => g.selected).length === 1" @click="showGrades(l, 'reporter_res')">
                  {{l.reporter_res.rate.filter(g => g.selected)[0].title}}
                </div>
                <input placeholder="请打分" class="scorer" v-if="l.is_available && l.reporter_res.score_type == 0" v-model="l.reporter_res.value" @blur="postScore(l.report_id, 0, l.reporter_res.value)">
                <div v-if="!l.is_available && l.reporter_res.score_type == 0" class="number">
                  {{l.reporter_res.value}}
                </div>
                <div class="gradeList" v-show="l.is_available && l.reporter_res.showGrades">
                  <div :class="{g: true, selected: g.selected}" v-for="(g, gi) in l.reporter_res.rate" :key="gi" @click="selectGrade(l, 0, g.key)">{{g.title}}</div>
                </div>
              </div>
              <div class="name sec">{{l.cameras}}</div>
              <div class="score sec">
                <div v-if="l.is_available && l.cameras_res.score_type == 1 && l.cameras_res.rate.filter(g => g.selected).length === 0" class="grade none" @click="showGrades(l, 'cameras_res')">
                  <img src="@assets/img/common/grade.svg" alt="grade">
                  打分
                </div>
                <div class="grade" v-if="l.cameras_res.score_type == 1 && l.cameras_res.rate.filter(g => g.selected).length === 1" @click="showGrades(l, 'cameras_res')">
                  {{l.cameras_res.rate.filter(g => g.selected)[0].title}}
                </div>
                <input placeholder="请打分" class="scorer" v-if="l.is_available && l.cameras_res.score_type==0" v-model="l.cameras_res.value" @blur="postScore(l.report_id, 1, l.cameras_res.value)">
                <div v-if="!l.is_available && l.cameras_res.score_type == 0" class="number">
                  {{l.reporter_res.value}}
                </div>
                <div class="gradeList" v-show="l.is_available && l.cameras_res.showGrades">
                  <div :class="{g: true, selected: g.selected}" v-for="(g, gi) in l.cameras_res.rate" :key="gi" @click="selectGrade(l, 1, g.key)">{{g.title}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="l.showRelated" class="related" v-for="(r, ri) in l.list" :key="ri">
            <div class="inner">
              <div class="title" @click="goReport(r.report_id)">
                <span class="typeIcon" :title="`${r.from}平台`">{{r.from}}</span>
                <span :title="`xnews报道标题`">{{r.title}}</span>
              </div>
              <div class="section">
                <img :title="`图片数`" src="@assets/img/common/image.svg" alt="image">
                <span class="count">{{r.img_num}}</span>
              </div>
              <div class="section">
                <img :title="`视频数`" src="@assets/img/common/video.svg" alt="video">
                <span class="count">{{r.video_num}}</span>
              </div>
              <div class="section mr20">
                <img :title="`视频总时长`" src="@assets/img/common/time.svg" alt="video">
                <span class="timeFont">{{r.report_durantion}}</span>
              </div>
              <div class="todo">
                <img :title="`发送到电视`" src="@assets/img/common/tv.svg" alt="tv">
                <span>电视</span>
                <img :src="r.push_avid?icons.done:icons.undone" alt="done">
              </div>
              <span class="sep">/</span>
              <div class="todo mr80">
                <span :title="`发送到knews`">Knews</span>
                <img :src="r.push_knews?icons.done:icons.undone" alt="done">
              </div>
            </div>
          </div>
        </div>
        <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
      </div>
    </div>
  </div>
</template>

<script>
import evaluationFilter from '@components/evaluationFilter';
import common from '@common/common';
import pages from '@components/pages';
import { apis } from '@common/config';
import empty from '@components/empty';

export default {
  name: 'sectionEvaluation',
  components: {
    evaluationFilter, pages, empty
  },
  data() {
    return {
      isXnew: this.$store.state.isXnew,
      isShow: false,
      icons: {
        up: require('@assets/img/common/upward.svg'),
        down: require('@assets/img/common/xiala.svg'),
        done: require('@assets/img/common/done.svg'),
        undone: require('@assets/img/common/undone.svg')
      },
      filters: [],
      dateConfig: {
        title: '播出日期',
        type: 'date',
        range: true,
        placer: '请选择播出日期'
      },
      page: {
        pageSize: 20,
        pageIndex: 1,
        page_count: 0,
        total: 0
      },
      filterOptions: {},
      list: [],
      download_type: 0
    }
  },
  mounted() {
    const yesterday = this.getYesterday()

    this.$refs.evaluationFilter.datePicker = yesterday
  },
  methods: {
    getList() {
      const id = this.$route.params.id
      const info = {
        idstring: id,
        column_id: '',
        start: '',
        end: '',
        status: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      Object.assign(info, this.filterOptions)

      common.myFetch(apis.sectionEvaluation, info)
        .then((data) => {
          if (data) {
            this.list = data.list
            this.generateFilters(data.params.list_search)
            this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
            this.$set(this.page, 'total', data.page.row_count - 0)
          }
        })
    },
    generateFilters(data) {
      // 整理过滤条件数据
      this.filters.forEach((i) => {
        data.forEach((j) => {
          if (i.key === j.key) {
            j.expand = !!i.expand
          }

          if (i.list) {
            i.list.forEach((c) => {
              j.list && j.list.forEach((d) => {
                if (c.key === d.key) {
                  d.expand = !!c.expand
                }
              })
            })
          }
        })
      })

      const filters = data.filter((i) => {
        return i.key !== 'start' && i.key !== 'end'
      })

      this.filters = filters
    },
    showGrades(i, s) {
      // 显示等级列表
      if (!i.is_available) return

      this.$set(i[s], 'showGrades', !i[s].showGrades)
    },
    toggleRelated(l) {
      // 切换显示隐藏关联报道
      this.$set(l, 'showRelated', !l.showRelated)
    },
    getFilters(f) {
      // 接收过滤组件数据
      this.page.pageIndex = 1
      this.filterOptions = f

      this.getList()
    },
    getYesterday() {
      const today = +new Date()
      const yesterday = today - 24 * 60 * 60 * 1000

      return [new Date(yesterday), new Date(yesterday)]
    },
    async selectGrade(l, type, score) {
      // 选择等级
      this.$set(l.reporter_res, 'showGrades', false)

      if (!score) {
        let c = await this.$confirm('确定清空打分吗？')

        if (!c) return
      }

      this.postScore(l.report_id, type, score)
    },
    postScore(id, type, score) {
      // 考评打分
      // if (!score) return

      const info = {
        report_id: id,
        appraisal_type: type,
        appraisal_res: score
      }

      common.myFetch(apis.sectionEvaluationScore, info)
        .then((r) => {
          if (r) {
            this.$toast(r)
          }

          this.getList()
        })
    },
    goReport(id) {
      // 跳转报道详情
      common.jump(`/reportDetail?d=${id}`, true)
    },
    goTandem(t) {
      // 跳转串联单详情页
      if (!t.id) return

      common.jump(`/tandem?d=${t.id}`, true)
    },
    goPrint() {
      // 打印打分
      const emptyObj = {
        list: []
      }
      const id = ((this.filters.filter(i => i.key === 'column_id')[0] || emptyObj).list.filter(i => i.selected)[0] || {}).key
      const st = this.filterOptions.start
      const et = this.filterOptions.end
      const s = ((this.filters.filter(i => i.key === 'status')[0] || emptyObj).list.filter(i => i.selected)[0] || {}).key

      common.jump(`/print?d=${id || ''}&st=${st}&et=${et}&s=${s || ''}`, true)
    },
    exportRes() {
      // 导出打分
      const info = {
        column_id: '',
        status: '',
        start: '',
        end: '',
        download_type: this.download_type
      }
      const userKeys = common.userKeys()
      const params = Object.assign({}, info, userKeys, this.filterOptions)
      const url = apis.sectionEvaluationExport

      common.exportRes(url, params)
    }
  }
}
</script>

<style lang="less" src="@assets/css/evaluation/evaluation.less" scoped></style>